import { ActivityItem, CreateOriginFields, SupplierType } from "../types";

type EditingState = {
  editingIds: Set<number>;
  editDataMap: Record<number, CreateOriginFields & { supplier: SupplierType }>;
  expandedAccordions: number[];
};

export function prepareEditingState(
  items: ActivityItem[],
  prevEditDataMap: Record<
    number,
    CreateOriginFields & { supplier: SupplierType }
  >,
  prevEditingIds: Set<number>,
  prevExpandedAccordions: number[],
  lastEditedId: number | null,
): EditingState {
  const noSupplier = items.filter((item) => {
    if (!item.supplier && item.id !== lastEditedId) {
      return true;
    }
    return false;
  });

  const updatedEditingIds = new Set(prevEditingIds);
  const updatedEditDataMap: Record<
    number,
    CreateOriginFields & { supplier: SupplierType }
  > = {
    ...prevEditDataMap,
  };
  const updatedExpanded = new Set<number>();

  noSupplier.forEach((item) => {
    updatedEditingIds.add(item.id);
    updatedEditDataMap[item.id] = {
      supplier: item.supplier || prevEditDataMap[item.id]?.supplier || null,
      supplier_id: prevEditDataMap[item.id]?.supplier_id ?? 0,
      execution_date:
        item.execution_date || prevEditDataMap[item.id]?.execution_date || null,
      completion_date:
        item.completion_date ||
        prevEditDataMap[item.id]?.completion_date ||
        null,
      comment: item.comment || prevEditDataMap[item.id]?.comment || "",
    };
    updatedExpanded.add(item.id);
  });

  if (lastEditedId !== null) {
    updatedExpanded.add(lastEditedId);
  }

  if (!noSupplier.length && !lastEditedId && items[0]) {
    updatedExpanded.add(items[0].id);
  }

  return {
    editingIds: updatedEditingIds,
    editDataMap: updatedEditDataMap,
    expandedAccordions: Array.from(updatedExpanded),
  };
}
